import { type DashMessages } from 'intl/intl.types'
import { errors } from 'utils/error-handling/errors'

export const slugToIntlKey = (slug: string): DashMessages => {
  switch (slug) {
    case 'top-aisles':
      return 'generatedReports.list.dataset.topAisles'
    case 'top-departments':
      return 'generatedReports.list.dataset.topDepartments'
    case 'store-level-performance':
      return 'generatedReports.list.dataset.storeLevelPerformance'
    default: {
      errors.captureMessage(`No translation defined for report with slug="${slug}"`)

      return 'generatedReports.list.dataset.unknown'
    }
  }
}
